import {
  APIColumnsResponse,
  APISearchResponse,
  DataSourceType,
  EnhancedSearchStrategy,
  ReportColumn,
  ReportColumnType,
} from '@ardoq/api-types';
import {
  enrichColumnsWithNumberFormatOptions,
  mergeDateRangeFieldsInResponse,
  mergeDateRangeFieldsInResponseWithoutScopeData,
} from './utils';
import { enhancePartialScopeData } from '@ardoq/renderers';
import { EnhancedSearchResponse } from './types';

const mergeDateRangeFieldsAndEnhanceScopeData = (
  searchResults: APISearchResponse
): EnhancedSearchResponse => {
  if (!searchResults.scopeData)
    return mergeDateRangeFieldsInResponseWithoutScopeData(searchResults);

  const enhancedScopeData = enhancePartialScopeData(searchResults.scopeData);
  const enrichedColumns = enrichColumnsWithNumberFormatOptions(
    searchResults.columns,
    enhancedScopeData
  );

  return mergeDateRangeFieldsInResponse({
    ...searchResults,
    columns: enrichedColumns,
    scopeData: enhancedScopeData,
  });
};

const getFilterableColumns = ({
  columns,
}: EnhancedSearchResponse): ReportColumn[] =>
  columns.filter(column => column.type !== ReportColumnType.GREMLIN_PATH);

const getName = ({ name }: EnhancedSearchResponse) => name;

const transformColumnsResponseToSearchResponse = (
  columnsResponse: APIColumnsResponse
): APISearchResponse => ({
  ...columnsResponse,
  results: [],
  aggregates: null,
  goneColumns: [],
  datasource: DataSourceType.GREMLIN_SEARCH,
  description: null,
  name: '',
  selectedAggregate: null,
  strategy: EnhancedSearchStrategy.SIMPLE_LIST_STRUCTURE,
  totalNumberOfRows: 0,
  filters: undefined,
  scopeData: columnsResponse.scopeData
    ? {
        ...columnsResponse.scopeData,
        attachments: [],
        users: [],
      }
    : null,
});

const isAPISearchResponse = (
  response: APISearchResponse | APIColumnsResponse
): response is APISearchResponse => {
  return 'results' in response;
};

export const searchResultsOperations = {
  mergeDateRangeFieldsAndEnhanceScopeData,
  getFilterableColumns,
  getName,
  transformColumnsResponseToSearchResponse,
  isAPISearchResponse,
};
